import React, { useState } from 'react';
import cx from 'classnames';
import { Button, Input } from 'antd';
import { useRequest } from 'ahooks';
import styles from '@/page-components/detail/Intro/styles.module.less';
import { apiShequDoCouponChange } from '@/services/coupon';
import { TCouponItem } from '@/page-components/detail/Intro/Coupon/couponItem';

type TCouponChange = {
  isOrganizationAdmin?: boolean;
  onChangeSuccess: (data: TCouponItem) => void;
  isMySelfSignup?: boolean;
};

const CouponChange: React.FC<TCouponChange> = ({
  isMySelfSignup,
  isOrganizationAdmin,
  onChangeSuccess,
}) => {
  const [msg, setMsg] = useState<{
    status: 'hidden' | 'success' | 'error';
    msg: string;
  }>({
    status: 'hidden',
    msg: '',
  });
  const [code, setCode] = useState('');
  const { run: doCouponChange, loading: doCouponChangeLoading } = useRequest(
    () => {
      return apiShequDoCouponChange({ cpcode: code });
    },
    {
      manual: true,
      onSuccess: (res) => {
        console.log('兑换结果是');
        console.log(res);
        if (res.code === 200) {
          if (res.status === -1) {
            setMsg((prevState) => {
              return { ...prevState, status: 'error', msg: res.message };
            });
          } else {
            // 10位时间戳变13位
            onChangeSuccess({
              ...res.data,
              etime:
                String(res.data.etime).length === 10
                  ? res.data.etime * 1000
                  : res.data.etime,
            });
            setMsg((prevState) => {
              return { ...prevState, status: 'success', msg: '兑换成功' };
            });
          }
        }
      },
    },
  );
  return (
    <>
      <div className={styles.input_row}>
        <Input
          disabled={!isMySelfSignup && isOrganizationAdmin === true}
          placeholder="请输入16位兑换码"
          onChange={(e) => {
            setCode(e.target.value);
          }}
        />
        <Button
          loading={doCouponChangeLoading}
          disabled={!code || doCouponChangeLoading}
          type="primary"
          className={styles.btn}
          onClick={() => {
            doCouponChange();
          }}
        >
          兑换
        </Button>
      </div>
      {msg.msg && (
        <p
          className={cx(
            styles.error_tips,
            msg.status === 'success' && styles.success_tips,
            msg.status === 'error' && styles.error_tips,
          )}
        >
          {msg.msg}
        </p>
      )}
    </>
  );
};
export default CouponChange;
